import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { ExternalsParametersService } from './services/externals-parameters.service';
import { ThemesService } from './services/themes.service';
import { UsersService } from './services/users.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NavMenuComponent } from './components/core/nav-menu/nav-menu.component';
import { NgClass } from '@angular/common';
import { MatSidenavContainer, MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { NavTopBarComponent } from './components/core/nav-top-bar/nav-top-bar.component';
import { DateAdapter } from '@angular/material/core';
import { User } from './models/user';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavTopBarComponent, MatSidenavContainer, MatSidenav, NgClass, NavMenuComponent, RouterOutlet, NgxSpinnerModule, MatSidenavModule],
})
export class AppComponent implements OnInit, OnDestroy {
    private router = inject(Router);

    title = 'app';
    showNav = false;
    showMenu = true;

    public currentUserSubscription: Subscription;

    private externalParametersChange: Subscription;

    private currentuser: User;

    constructor(
        private usersService: UsersService,
        private translateService: TranslateService,
        private themesService: ThemesService,
        private externalsParametersService: ExternalsParametersService,
        private dateAdapter: DateAdapter<any>
    ) {
        // Abonnement à l'évènement du changement de langue au service de traduction
        translateService.onLangChange.subscribe((e: Event) => {
            this.dateAdapter.setLocale(translateService.currentLang);
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (event.url.includes('changepassword') || event.url.includes('forgottenpassword')) {
                this.showNav = false;
            } else {
                if (this.currentuser) {
                    this.showNav = true;
                }
            }
        });
    }

    ngOnInit() {
        this.themesService.changeTheme(this.themesService.getCurrentTheme());
        const currentLang = sessionStorage.getItem('language');

        if (!!currentLang) {
            this.translateService.setDefaultLang(currentLang);
            this.translateService.use(currentLang);
        } else {
            let browserLanguage = this.translateService.getBrowserCultureLang();

            // Les navigateurs ne retournant pas les mêmes valeurs (ex français: Chrome fr-FR, Firefox fr)
            // utilisation seulement des 2 premières lettres
            browserLanguage = browserLanguage.substring(0, 2);

            this.translateService.setDefaultLang(browserLanguage);
            this.translateService.use(browserLanguage);
        }

        // S'il y a des paramètres externes, le menu n'est pas affiché
        this.externalParametersChange = this.externalsParametersService.externalParametersChange$.subscribe((parameters) => {
            if (!!parameters && !!this.currentuser) {
                this.showNav = true;
            }
        });

        this.currentUserSubscription = this.usersService.currentUserSubject.subscribe({
            next: (user) => {
                this.currentuser = user;
                if (!!user) {
                    this.showNav = true;
                } else {
                    this.showNav = false;
                }
            },
            error: () => {
                this.showNav = false;
            },
        });
    }

    onShowMenu(MenuShowed: boolean) {
        this.showMenu = MenuShowed;
    }

    ngOnDestroy() {
        if (this.currentUserSubscription) {
            this.currentUserSubscription.unsubscribe();
        }

        this.externalParametersChange.unsubscribe();
    }
}
